module.exports = __webpack_public_path__ + "static/img/yingrenSkill.ce08f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/yingrenSkill.png
// module id = srB8
// module chunks = 0